import { SharedTenantInfo } from '@@types/Channel';
import { CHANNEL_ID, StringTMap, TENANT_ID } from '@@types/common';

import { mainDetailUiState } from '~/stores/DetailUiState';
import { uiState } from '~/stores/UiState';
import { isNonEmpty, keyBy } from '~/utils/fnUtil/fnUtil';
import { action, computed, observable } from 'mobx';
import { always, ifElse, pipe, values } from 'ramda';

class ChannelTenantsStore {
  @observable
  channelIdTenantMap: StringTMap<StringTMap<SharedTenantInfo>> = {};

  @computed
  get contentsChannelTenantInfoMap() {
    return this.getByChannelId(mainDetailUiState.contentsChannelId);
  }

  @computed
  get contentsChannelTenantInfoList() {
    return this.getTenantInfoList(mainDetailUiState.contentsChannelId);
  }

  getByChannelId = (channelId: CHANNEL_ID): StringTMap<SharedTenantInfo> => {
    return this.channelIdTenantMap[channelId] ?? {};
  };

  getTenantInfoList = (channelId: CHANNEL_ID): SharedTenantInfo[] => {
    return pipe(this.getByChannelId, ifElse(isNonEmpty, values, always([])))(channelId);
  };

  isHostTenant = (channelId: CHANNEL_ID, tenantId: TENANT_ID) => {
    return this.getByChannelId(channelId)[tenantId]?.host ?? false;
  };

  @action
  setTenantInfoList = (channelId: CHANNEL_ID, tenantList: SharedTenantInfo[]) => {
    this.channelIdTenantMap = uiState.pickAndSetLruChannelIds(
      channelId,
      keyBy('id', tenantList)
    )(this.channelIdTenantMap);
  };
}

export default ChannelTenantsStore;

export const channelTenantsStore = new ChannelTenantsStore();
